module.exports = __webpack_public_path__ + "img/contract_top3.930a1ff3.png";